import { useId } from "react";
import { Button, ChevronsUpDown, Plus } from "@repo/ui";

type Props = {
  onClickAdd?: () => void;
  addButtonLabel?: string;
  isSortable?: boolean;
  addButtonId?: string;
};

export const WorkflowsTableFooter = ({
  onClickAdd,
  addButtonLabel,
  isSortable,
  addButtonId,
}: Props) => {
  const generated = useId();
  const id = addButtonId ?? `add-button-${generated}`;

  return (
    <div className="mx-7 flex items-center justify-between border-t border-gray-300 pt-3 pb-6">
      <div className="flex items-center gap-2">
        <Button
          id={id}
          size="icon_sm"
          className="h-5 w-5"
          data-allow-navigation
          icon={<Plus size="18px" />}
          onClick={() => {
            onClickAdd?.();
          }}
        />
        {addButtonLabel && (
          <label className="cursor-pointer" htmlFor={id}>
            {addButtonLabel}
          </label>
        )}
      </div>
      {isSortable && (
        <div className="flex items-center gap-2">
          <ChevronsUpDown size="16px" className="text-gray-600" />
          <span className="text-xs text-gray-600">Drag items to reorder</span>
        </div>
      )}
    </div>
  );
};
